<script lang="ts" setup>
import IconCamera from '@/shared/icons/IconCamera.vue';
import { goTakePhoto } from '@/shared/utils/routeNavigate';
import { useStepVistoria } from '@/stores/stepVistoria';
import { TIPO_ETAPA_FOTO } from '@/global';

const vistoriaStore = useStepVistoria();
</script>

<template>
  <div
    class="card buttonTakePhoto"
    role="button"
    @click="goTakePhoto()"
    v-if="vistoriaStore.currentVistoriaEtapa?.tipo === TIPO_ETAPA_FOTO"
  >
    <span>Tirar Foto</span>
    <IconCamera />
  </div>
</template>

<style lang="scss">
.buttonTakePhoto {
  cursor: pointer;
  margin-top: 0.8rem;
  padding: 1rem;
  display: flex;
  flex-direction: row !important;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  color: var(--primary);

  svg {
    display: block;
    width: 2rem;
    height: 2rem;
  }
}
</style>
